import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'forbidden',
    templateUrl: './forbidden.component.html',
    styleUrls: ['./forbidden.component.scss'],
    standalone: true
})
export class ForbiddenComponent implements OnInit {
  constructor (private router: Router) { }

  ngOnInit (): void {
      setTimeout((router: Router) => {
          this.router.navigate(["/"]);
      }, 10000);
  }
}
